import { FormControl, Select, MenuItem, Typography, Box } from "@mui/material";

const menuProps = {
  PaperProps: {
    sx: {
      mt: 0.5,
      maxHeight: 280,
      width: "auto",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
      },
      "& .MuiMenuItem-root": {
        px: 2,
        py: 1.2,
        fontSize: "0.95rem",
        "&:hover": {
          backgroundColor: "action.hover",
        },
        "&.Mui-selected": {
          backgroundColor: "primary.lighter",
          color: "primary.main",
          fontWeight: 600,
          "&:hover": {
            backgroundColor: "primary.lighter",
          },
        },
      },
    },
  },
  // Keeps menu from opening upward/overlapping the trigger oddly
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const FormSelect = ({
  label,
  value,
  onChange,
  options = [],
  multiple = false,
  required = false,
  fullWidth = true,
  disabled = false,
  name,
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Box>
      <Typography
        variant="body2"
        sx={{ fontSize: 12.5, fontWeight: 650, color: "#3A4441", mb: 0.75 }}
      >
        {label}
        {required && (
          <Box component="span" sx={{ color: "error.main", ml: 0.5 }}>
            *
          </Box>
        )}
      </Typography>

      <FormControl fullWidth={fullWidth} disabled={disabled}>
        <Select
          value={value}
          onChange={handleChange}
          multiple={multiple}
          name={name}
          displayEmpty
          notched={false}
          MenuProps={menuProps}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E6ECEA",
            },
            "&.Mui-focused": {
              boxShadow: "0px 2px 10px rgba(27, 27, 27, 0.1)",
            },
          }}
        >
          {!required && !multiple && <MenuItem value="">All {label}</MenuItem>}
          {options?.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
export default FormSelect;
